var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92439 1.51514H3.38438C3.03397 1.51514 2.74921 2.17373 2.74921 2.98488C2.74921 3.79708 3.03397 4.45462 3.38438 4.45462H6.92439C7.27586 4.45462 7.55956 3.79708 7.55956 2.98488C7.55956 2.17268 7.27586 1.51514 6.92439 1.51514Z",
    fill: "#0D2038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2.74921 2.98488L6.92439 1.51514H3.38438C3.03397 1.51514 2.74921 2.17268 2.74921 2.98488Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2406 0H14.0553C12.3075 0 10.745 0.860593 10.1468 2.15253C10.0463 2.45974 9.96053 2.73433 9.88113 2.98472H0.981338C0.439326 2.98472 0 3.42133 0 3.95999V26.8667C0 27.4054 0.439326 27.8409 0.981338 27.8409H34.0187C34.5607 27.8409 35 27.4043 35 26.8667V7.06991V3.95999V1.61703C34.9989 0.723824 34.2124 0 33.2406 0Z",
    fill: "#C8C8C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7.23926H0V25.2991H35V7.23926Z",
    fill: "#0099C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 16.9751H0V25.2991H35V16.9751Z",
    fill: "#007296"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3285 5.52637C11.8343 5.52637 7.37964 9.95348 7.37964 15.4127C7.37964 20.8729 11.8343 25.299 17.3285 25.299C22.8227 25.299 27.2764 20.8719 27.2764 15.4127C27.2764 9.95243 22.8227 5.52637 17.3285 5.52637Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9253 8.99409C8.35885 11.9588 7.88564 17.237 10.8699 20.7815L23.7871 10.0441C20.804 6.49963 15.4929 6.02936 11.9253 8.99409Z",
    fill: "#364D5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8709 20.7814C13.8541 24.3269 19.1641 24.7961 22.7306 21.8304C26.2982 18.8656 26.7703 13.5884 23.7871 10.043L10.8709 20.7814Z",
    fill: "#364D5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.9253 8.99409C8.9866 11.438 8.15135 15.4506 9.61648 18.771C8.66373 15.6547 9.59954 12.1377 12.2704 9.91675C15.838 6.95202 21.148 7.42124 24.1312 10.9667C24.6563 11.5906 25.0723 12.2681 25.3846 12.9772C25.0659 11.9336 24.5356 10.9341 23.7861 10.0441C20.8039 6.49963 15.4929 6.02935 11.9253 8.99409Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0299 1.34131H28.0015C27.8543 1.34131 27.7347 1.72531 27.7347 2.19875V3.72109C27.7347 4.19452 27.8543 4.57747 28.0015 4.57747H33.0299C33.1771 4.57747 33.2967 4.19347 33.2967 3.72109V2.19875C33.2967 1.72531 33.1771 1.34131 33.0299 1.34131Z",
    fill: "#364D5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9293 3.57715H28.174V3.92959H32.9293V3.57715Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9293 2.81006H28.174V3.1625H32.9293V2.81006Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9293 2.04395H28.174V2.39639H32.9293V2.04395Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.05 9.70557L10.7471 15.392L14.05 21.0784H20.6578L23.9607 15.392L20.6578 9.70557H14.05Z",
    fill: "#0E2037"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.3625 10.5259C10.7661 10.5259 9.47357 11.8115 9.47357 13.398C9.47357 14.9845 10.7672 16.2702 12.3625 16.2702C13.9589 16.2702 15.2515 14.9845 15.2515 13.398C15.2515 11.8115 13.9579 10.5259 12.3625 10.5259Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8189 14.8018C15.1869 14.8018 14.6745 15.311 14.6745 15.939C14.6745 16.5671 15.1869 17.0753 15.8189 17.0753C16.4509 17.0753 16.9622 16.5671 16.9622 15.939C16.9622 15.311 16.4509 14.8018 15.8189 14.8018Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.6736 16.6836C17.1729 16.6836 16.7685 17.0865 16.7685 17.5831C16.7685 18.0797 17.1739 18.4826 17.6736 18.4826C18.1743 18.4826 18.5777 18.0797 18.5777 17.5831C18.5787 17.0865 18.1743 16.6836 17.6736 16.6836Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.719a5af404b4d378d00fab0dae39a28e.svg";
export { ForwardRef as ReactComponent };